import { render, staticRenderFns } from "./DetectionWriteRequestLayout.vue?vue&type=template&id=0cd6327d&scoped=true"
import script from "./DetectionWriteRequestLayout.vue?vue&type=script&lang=js"
export * from "./DetectionWriteRequestLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd6327d",
  null
  
)

export default component.exports